import { useTranslation } from 'react-i18next';

import { useLocales } from 'src/locales/use-locales';
import { CONFIG, SOCIAL_LINKS } from 'src/config-global';
import type { JsonLdDocument } from 'src/types/json-ld';

export function useHomeStructuredData(): JsonLdDocument[] {
  const { t } = useTranslation('home');
  const { t: tFooter } = useTranslation('footer');
  const { currentLang } = useLocales();

  const organization: JsonLdDocument = {
    '@type': 'Organization',
    url: `${CONFIG.siteUrl}/`,
    '@context': 'https://schema.org',
    name: tFooter('registry.company'),
    logo: `${CONFIG.siteUrl}/somnus.svg`,
    description: t('organization.description'),
    sameAs: [SOCIAL_LINKS.linkedin, SOCIAL_LINKS.facebook],
    address: {
      '@type': 'PostalAddress',
      streetAddress: tFooter('registry.street'),
      postalCode: tFooter('registry.postalCode'),
      addressLocality: tFooter('registry.locality'),
      addressCountry: tFooter('registry.countryCode'),
    },
  };

  const website: JsonLdDocument = {
    '@type': 'WebSite',
    name: CONFIG.siteName,
    url: `${CONFIG.siteUrl}/`,
    '@context': 'https://schema.org',
    inLanguage: currentLang.ogLocale.replace('_', '-'),
  };

  const faqPage: JsonLdDocument = {
    '@type': 'FAQPage',
    '@context': 'https://schema.org',
    mainEntity: t('faq.items', { returnObjects: true }).map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };

  return [organization, website, faqPage];
}
